(() => {
  // app/scripts/filter-component.js
  var { debounceTime, addEvent } = theme;
  customElements.define("filter-component", class extends HTMLElement {
    constructor() {
      super();
      this.container = this.closest("[data-section-id]");
    }
    connectedCallback() {
      if (this.initialized) {
        this.clearLoadingState();
        window.addEventListener("popstate", this.onPopState);
        return;
      }
      this.initialized = true;
      this.cache = [];
      this.requestVersion = 0; 
      this.andLogic = JSON.parse(this.dataset.andLogic || "false");
      this.filterType = this.dataset.type || "attribute";
      this.form = this.querySelector("form");
      this.inputClass = `input[form="${this.form.id}"]`;
      this.onPopState = () => {
        if (location.pathname === new URL(this.form.action).pathname) this.submit(location.href);
      };
      window.addEventListener("popstate", this.onPopState);
      this.addEvents();
    }
    // addEvents(){
    //   this.addEventListener('change', ({target})=>{
    //     let selectedTarget = target;
    //     // if(selectedTarget.name == 'sortBy'){// Fix duplicate sort input
    //     //   const sortEl = [...this.querySelectorAll('[name=sort_by]')].find(item=>item.value == selectedTarget.value);
    //     //   sortEl.checked = true;
    //     //   selectedTarget = sortEl;
    //     // }
    //     // if(selectedTarget.name == 'paginateViewClone'){// Fix duplicate total view
    //     //   const element = [...document.querySelectorAll('[name=paginateView]')].find(item=>item.value == selectedTarget.value);
    //     //   element.checked = true;
    //     //   element.closest('cart-update-component').setValue = element;
    //     //   return;
    //     // }
    //     let timeout = 100;
    //     const inputList = this.querySelectorAll(this.inputClass);
    //     inputList?.forEach(input=>{
    //       input.addEventListener('change', debounceTime((e)=>this.onChange(e), timeout).bind(this));
    //     });
    //     // this.onChange(selectedTarget);
    //   })
    //   this.form.addEventListener('submit', e=>{
    //     e.preventDefault();
    //     this.submit();
    //   });
    //   // Remove all checked input in filter popup
    //   this.querySelector('.jsFilterReset')?.addEventListener('click', e=>{
    //     e.preventDefault();
    //     this.uncheckInput();
    //     this.submit();
    //   });
    //   this.removeFilter();
    //   this.filterSearch();
    // }
    addEvents() {
      this.addEventListener("click", (e) => {
        if (e.target.hasAttribute("auto-submit")) {
          if (e.target.checked) {
            this.querySelectorAll(`#${e.target.id}`).forEach((item) => {
              item.checked = true;
            });
          } else {
            this.querySelectorAll(`#${e.target.id}`).forEach((item) => {
              item.checked = false;
            });
          }
          this.autoSumit = true;
        }
        const link = e.target.closest("a[data-pagination-link]");
        if (link && this.contains(link) && !e.defaultPrevented && e.button === 0 && !e.ctrlKey && !e.metaKey && !e.shiftKey && !e.altKey && !link.hasAttribute("download") && (!link.target || link.target === "_self")) {
          const url = new URL(link.href, this.form.action);
          const action = new URL(this.form.action);
          if (url.origin !== action.origin || url.pathname !== action.pathname) return;
          e.preventDefault();
          this.submit(url.href, link);
        }
      });
      let timeout = 100;
      const inputList = this.querySelectorAll(this.inputClass);
      inputList?.forEach((input) => {
        input.addEventListener("change", debounceTime((e) => this.onChange(e), timeout).bind(this));
      });
      this.filterSearch();
    }
    onChange(e) {
      const input = e.target;
      !this.andLogic && this.uncheckInput(input);
      input.hasAttribute("auto-submit") && this.submit();
    }
    uncheckInput(input = null) {
      let inputList;
      if (input) {
        inputList = this.querySelectorAll(`input[name="${input.name}"][form="${this.form.id}"]:not([id="${input.id}"])`);
      } else {
        inputList = this.querySelectorAll(`input[form="${this.form.id}"]`);
      }
      inputList.forEach((i) => {
        i.removeAttribute("checked");
        i.checked = false;
      });
    }
    get getQueryString() {
      const formData = new FormData(this.form);
      const query = new URLSearchParams(formData);
      if (localStorage.getItem("utm_source") || window.location.href.includes("utm_source=")) {
        const params = new URL(window.location.href).searchParams;
        const utmSource = localStorage.getItem("utm_source") || params.get("utm_source");
        query.append("utm_source", utmSource);
      }
      if (this.filterType == "attribute")
        return query.toString();
      const arrayFilter = [];
      let sort = "";
      query.split("&").map((i) => {
        !i.includes("sort_by=") ? arrayFilter.push(i.split("=")[1]) : sort = i;
      });
      return arrayFilter.join("+") + (sort.length ? `?${sort}` : "");
    }
    async submit(pageUrl = null, trigger = null) {
      const version = ++this.requestVersion;
      this.requestController?.abort();
      this.requestController = new AbortController();
      let url;
      if (pageUrl) {
        // Use Shopify's complete pagination URL, including active filters and sort.
        url = new URL(pageUrl, this.form.action);
      } else {
        const query = this.getQueryString;
        url = new URL(this.form.action + (this.filterType === "attribute" ? "?" : "/") + query);
      }
      url.searchParams.delete("section_id");
      const navigationUrl = url.pathname + url.search + url.hash;
      const query = navigationUrl;
      const context = { trigger, version };
      const product = this.querySelector("#" + CSS.escape(this.dataset.product));
      product?.setAttribute("aria-busy", "true");
      this.announce(window.espAccessibilityStrings?.collectionLoading || "Loading products…");
      const findInCache = this.cache.find((i) => i.query === query);
      try {
      if (findInCache) {
        this.render(findInCache.DOM, navigationUrl, context);
        return;
      }
      url.searchParams.set("section_id", this.dataset.sectionId);
      const response = await fetch(url.href, { signal: this.requestController.signal });
      if (!response.ok) throw new Error("Collection request failed");
      const html = await response.text();
      if (!this.isConnected || version !== this.requestVersion) return;
        const div = document.createElement("div");
        div.innerHTML = html;
        if (!div.querySelector("#" + CSS.escape(this.dataset.product))) throw new Error("Collection response is incomplete");
        this.cache.push({
          query,
          DOM: div
        });
        this.render(div, navigationUrl, context);
      } catch (error) {
        if (error.name !== "AbortError" && version === this.requestVersion) this.announce(window.espAccessibilityStrings?.collectionError || "Products could not be loaded. Please try again.");
      } finally {
        if (version === this.requestVersion) product?.removeAttribute("aria-busy");
      }
    }
    announce(message) {
      if (!this.statusMessage) {
        this.statusMessage = document.createElement("div");
        this.statusMessage.className = "esp-visually-hidden";
        this.statusMessage.setAttribute("role", "status");
        this.statusMessage.setAttribute("aria-live", "polite");
        this.statusMessage.setAttribute("aria-atomic", "true");
        this.append(this.statusMessage);
      }
      this.statusMessage.textContent = message;
    }
    render(result, navigationUrl = null, context = {}) {
      if (context.version !== undefined && context.version !== this.requestVersion) return;
      const product = this.querySelector("#" + CSS.escape(this.dataset.product));
      const incoming = result.querySelector("#" + CSS.escape(this.dataset.product));
      if (!product || !incoming) return;
      const active = document.activeElement;
      const returnToPage = context.trigger && (active === context.trigger || context.trigger.contains(active));
      if (navigationUrl && location.pathname + location.search + location.hash !== navigationUrl) history.pushState({ collectionUrl: navigationUrl }, "", navigationUrl);
      this.querySelectorAll(this.inputClass).forEach((input, i) => {
        if (!input.id)
          return;
        input.checked = result.querySelector(`#${input.id}`)?.checked || false;
      });
      product.innerHTML = incoming.innerHTML;
      this.querySelectorAll(".jsFilterUpdate")?.forEach((item) => {
        const newItem = result.querySelector(`[class="${item.className}"]`);
        if (!newItem)
          return;
        item.innerHTML = newItem.innerHTML;
      });
      this.removeFilter();
      const pagination = this.querySelector("[data-pagination-status]");
      if (pagination?.dataset.paginationTitle) document.title = pagination.dataset.paginationTitle;
      if (pagination?.dataset.paginationStatus) this.announce(pagination.dataset.paginationStatus);
      if (returnToPage) {
        const destination = pagination?.querySelector('[aria-current="page"]') || product;
        destination.setAttribute("tabindex", "-1");
        destination.focus({ preventScroll: true });
        destination.scrollIntoView({ block: "center", behavior: "auto" });
      }
    }
    disconnectedCallback() {
      this.requestVersion++;
      this.requestController?.abort();
      this.clearLoadingState();
      window.removeEventListener("popstate", this.onPopState);
    }
    clearLoadingState() {
      this.querySelector("#" + CSS.escape(this.dataset.product))?.removeAttribute("aria-busy");
      if (this.statusMessage) this.statusMessage.textContent = "";
    }
    removeFilter() {
      this.querySelectorAll(".jsFilterRemove")?.forEach((item) => {
        item.addEventListener("click", (event) => {
          event.preventDefault();
          const value = item.querySelector(".jsValue").textContent;
          this.querySelectorAll(`input[form="${this.form.id}"]`).forEach((item2) => {
            if (item2.value != value)
              return;
            item2.checked = false;
          });
          this.submit();
        });
      });
    }
    filterSearch() {
      this.querySelectorAll(".jsFilterSearch").forEach((item) => {
        const parentEl = item.closest(".filter-block");
        item.addEventListener("click", () => {
          const value = item.previousElementSibling.value;
          searchFilterValue(parentEl, value);
          console.log("value", value, parentEl);
        });
        item.previousElementSibling.addEventListener("keyup", (e) => {
          (e.keyCode == 8 || !item.previousElementSibling.value.length) && clearField(parentEl);
          const value = item.previousElementSibling.value;
          searchFilterValue(parentEl, value);
        });
      });
      const clearField = (el) => {
        el.querySelectorAll("li.matched")?.forEach((item) => item.classList.remove("matched"));
      };
      const searchFilterValue = (container, value) => {
        const filterListItem = container.querySelectorAll("[name*=filter]");
        if (value.length) {
          container.classList.add("searching");
          filterListItem.forEach((item) => {
            let regex = new RegExp(value, "i");
            const parentEl = item.closest("li");
            parentEl.classList.toggle("matched", item.value.match(regex));
          });
        } else {
          container.classList.remove("searching");
          container.querySelectorAll(".matched")?.forEach((item) => item.classList.remove("matched"));
        }
        container.querySelector(".jsFilterShowMore")?.classList.toggle("none", value.length);
      };
    }
  });
  addEvent("click", ".jsFilterShowMore", ({ target }) => {
    const container = target.closest(".filter-block");
    const filterList = container.querySelectorAll(".jsFilterToggle.none");
    filterList.forEach((item, value) => {
      value < 10 && item.classList.remove("none");
    });
    const hiddenFilterCount = container.querySelectorAll(".jsFilterToggle.none").length;
    !hiddenFilterCount && target.classList.add("none");
    target.querySelector(".attr-count").setAttribute("data-count", Math.min(10, hiddenFilterCount));
  });
})();
